import { render, staticRenderFns } from "./StudioSelect.vue?vue&type=template&id=7844d6f2"
import script from "./StudioSelect.vue?vue&type=script&lang=ts"
export * from "./StudioSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports